var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.659,
    height: 21.693,
    viewBox: "0 0 17.659 21.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-1672.752 -39.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1688.256,54.8c0-1.581-.143-2.443-.143-5.46a9.13,9.13,0,0,0-3.448-7.183h-.641a2.443,2.443,0,0,0-4.885,0h-.64a9.129,9.129,0,0,0-3.448,7.183c0,3.017-.144,3.879-.144,5.46s-2.155-.431-2.155,3.017h17.659C1690.411,54.37,1688.256,56.381,1688.256,54.8Z",
    fill: "#113252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1679.139,58.967a2.443,2.443,0,0,0,4.885,0,2.353,2.353,0,0,0-.026-.253h-4.833A2.322,2.322,0,0,0,1679.139,58.967Z",
    fill: "#113252"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellP);
export default __webpack_public_path__ + "static/media/bellP.cbdc1888de70d4465e027e2bf4a4f289.svg";
export { ForwardRef as ReactComponent };